export default {
  'ec.footer.window': '贸片区国际贸易“单一窗口”',
  'ec.footer.policy': '黑龙江政务服务',
  'ec.footer.depart': '哈尔滨市企业开办直通车',

}